"use client";

import { useCallback, useRef } from "react";
import Image from "next/image";
import { StatCard } from "./stat-card";

const stats = [
  { value: "100%", label: "of conversations analyzed" },
  { value: "< 5 min", label: "to full account context" },
  { value: "Zero", label: "manual data entry" },
  { value: "Day 1", label: "time to value" },
];

export function LoginRightPanel() {
  const panelRef = useRef<HTMLDivElement>(null);

  const handleMouseMove = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const el = panelRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    el.style.setProperty("--mouse-x", x + "%");
    el.style.setProperty("--mouse-y", y + "%");
  }, []);

  return (
    <div
      ref={panelRef}
      onMouseMove={handleMouseMove}
      className="hidden md:flex flex-col items-center justify-center flex-1 login-hero-bg p-8 lg:p-12 gap-8"
    >
      <div className="login-hero-badge">
        <span className="login-hero-badge-dot" />
        AI-Powered Customer Intelligence
      </div>

      <h2 className="text-3xl lg:text-4xl font-bold text-center text-shark-gray-900 max-w-2xl leading-tight">
        Your customers are{" "}
        <span className="login-text-gradient">telling you everything.</span>{" "}
        You&apos;re just not hearing it.
      </h2>

      <Image
        src="/brand/dashboard-preview.png"
        alt="Skrift account profile dashboard"
        width={1400}
        height={954}
        className="w-full max-w-[700px] rounded-xl shadow-lg border border-shark-gray-200"
        priority
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 w-full max-w-[700px]">
        {stats.map((stat) => (
          <StatCard key={stat.value} value={stat.value} label={stat.label} />
        ))}
      </div>
    </div>
  );
}
